import { APP_DEFINITION_ID } from './appAndWidgetIds';

// Signup form configuration
export const SIGNUP_FORM_ID = '78384e16-7b4d-4fab-7227-f687b3545659';
export const SIGNUP_FORM_NAMESPACE = 'wix.identity.sm.v1.form';
export const APP_DASHBOARD_URL = `/app/${APP_DEFINITION_ID}/`;

// Lightbox viewer-context mode set by thunderbolt when the signup form is opened as the
// complete-profile popup. Must match COMPLETE_PROFILE_POPUP_MODE in thunderbolt feature-site-members.
export const COMPLETE_PROFILE_MODE = 'completeProfile';
